module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ingenieur-imac.fr/"
    }
  }, [_vm._v("Retour au site ingénieur IMAC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75bea344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 105
// module chunks = 1